// Place all the behaviors and hooks related to the matching controller here.
// All this logic will automatically be available in application.js.

document.addEventListener("turbolinks:load", function () {
    console.log('trip_descriptions.js load cocoon');
    $(document)
        .on('cocoon:after-insert', function (e, added_record) {
            // set focus to stop
            $(added_record).find('td > select.stop_id').focus();
            // set sequence
            if ($(added_record).prevAll('tr').length > 0) {
                let $prev_record = $(added_record).prevAll('tr').first();
                let $prev_seq = $prev_record.find('td > input.stop_sequence').val();
                if ($prev_seq) {
                    $(added_record).find('td > input.stop_sequence').val(parseInt($prev_seq) + 1);
                }
            } else {
                $(added_record).find('td > input.stop_sequence').val("1");
            }
            // set default delta
            $(added_record).find('td > input.delta').val("1");
        })
});